module.exports = __webpack_public_path__ + "static/media/ic_condtion.79d06d64.png";